export const formatCurrency = (currencyCode: string, amountInSmallestUnit: number) => {
  const amountInLargestUnit = amountInSmallestUnit / 100

  return `${currencyCode.toUpperCase()}${amountInLargestUnit.toFixed(2)}`
}
